import React from "react";

const Home = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1222.59 1000"
    >
      <defs>
        <clipPath id="clip1">
          <path d="M0 1h1222.59v999H0zm0 0"></path>
        </clipPath>
      </defs>
      <g>
        <g clipPath="url(#clip1)">
          <path fill="transparent" d="M1222.59 1001.5H0V1.504h1222.59V1001.5"></path>
        </g>
        <path
          fill="#E1F4FD"
          d="M1059.031 602.441c0 14.868-.73 29.57-2.172 44.07-6.629 67.31-28.32 130.2-61.632 185.27-.309.528-.63 1.047-.95 1.57H236.31a442.827 442.827 0 01-33.203-66.273 441.379 441.379 0 01-23.57-80.457c-1.27-6.59-2.391-13.23-3.36-19.922a448.2 448.2 0 01-4.621-64.258c0-245.07 198.672-443.742 443.742-443.742 245.058 0 443.734 198.672 443.734 443.742"
        ></path>
        <path
          fill="#FFF"
          d="M597.77 329.059a32.201 32.201 0 01-.524-5.73c0-17.56 14.234-31.794 31.793-31.794 12.066 0 22.559 6.719 27.945 16.617 5.047-5.246 12.137-8.515 19.993-8.515a27.64 27.64 0 0112.828 3.144c6.004-10.972 17.656-18.418 31.05-18.418 2.907 0 5.727.36 8.43 1.02 4.992-16.824 20.559-29.098 39-29.098 20.73 0 37.824 15.512 40.348 35.555a32.24 32.24 0 014.367-.305c17.559 0 31.797 14.235 31.797 31.793 0 1.957-.188 3.871-.527 5.73h-246.5M439.59 315.691c-6.965 0-13.29 2.672-18.067 7.016-6.68-10.816-18.609-18.05-32.253-18.05-20.946 0-37.926 16.98-37.926 37.921H466.48c0-14.848-12.039-26.887-26.89-26.887M942.55 404.184c7.184 0 13.712 2.753 18.638 7.238 6.89-11.16 19.195-18.625 33.273-18.625 21.61 0 39.117 17.515 39.117 39.121H914.816c0-15.316 12.418-27.734 27.735-27.734"
        ></path>
        <path
          fill="#C1E4F8"
          d="M413.7 477.96l-34.255-14.683 18.524-1.609-9.024-12.723-46.543-11.953 11.512-2.258-29.45-46.046-5.202 31.613-32.602 28.644 11.832 4.364-35.328 13.054-11.21 18.535 32.214-.336-40.32 23.684v21.73l45.09-13.964-2.278 2 11.832 4.36-35.328 13.058-11.21 18.535 32.214-.336-40.32 23.68v21.734l56.047-17.36 24.57-30.14 89.234 18.68v-23.196l-34.254-14.683 18.524-1.61-9.024-12.722-42.96-14.242-3.262-17.47 70.976 14.856v-23.195"
        ></path>
        <path
          fill="#C1E4F8"
          d="M331.96 687.527H318v-151.73h13.96v151.73"
        ></path>
        <path
          fill="#C1E4F8"
          fillRule="evenodd"
          d="M649.39 256.11c1.731-2.208.895-4.708-3.785-5.731l-.003-.004-.004-.004-.012-.016c-.106-.128-.211-.257-.316-.39l-.036-.04c-.082-.1-.164-.198-.246-.3-.039-.043-.074-.086-.11-.129-.003-.008-.007-.012-.01-.016l-.009-.007-.246-.286c-.047-.05-.093-.105-.14-.16a8.408 8.408 0 00-.254-.273c-.043-.043-.082-.09-.125-.133a.03.03 0 00-.016-.016l-.015-.015c-.083-.082-.165-.164-.25-.246a8.05 8.05 0 00-.184-.18c-.082-.078-.172-.152-.258-.23-.07-.059-.133-.118-.203-.176a7.72 7.72 0 00-.281-.219c-.074-.059-.145-.117-.219-.172-.098-.07-.2-.137-.3-.203-.083-.05-.157-.11-.24-.16-.1-.063-.21-.121-.316-.184-.09-.05-.175-.101-.269-.152-.11-.059-.23-.11-.352-.164-.093-.047-.183-.094-.285-.137-.125-.058-.261-.105-.398-.156-.098-.035-.192-.078-.293-.113-.14-.047-.293-.09-.442-.133-.101-.031-.203-.067-.312-.094-.145-.039-.3-.07-.453-.101-.121-.028-.238-.06-.367-.083-.157-.03-.325-.05-.489-.078-.136-.02-.261-.043-.402-.058-.184-.024-.375-.035-.563-.051-.136-.012-.265-.027-.41-.035-.336-.02-.683-.031-1.047-.031l-45.87.004-3.903-4.79h-2.285l1.96 4.79h-10.898l-10.445-5.149-8.34-10.676h-9.824l7.3 15.825h.477-.476l-4.54 1.761-.066-.02h-3.843l1.562.93-2.27.883v3.254c7.825 2.195 13.735 3.89 18.336 5.168 4.23 1.223 6.918 2.016 9.852 2.524 2.426.515 4.223.746 5.824.746h2.485c7.754.257 20.578 0 48 0 3.175 0 11.023.109 15.945-1.59.238-.082.473-.172.7-.262.066-.027.124-.055.19-.078.172-.074.344-.152.508-.227.055-.023.106-.05.157-.074.21-.101.41-.203.605-.308a.527.527 0 01.102-.06c.16-.093.312-.183.465-.276.046-.036.097-.067.148-.098.148-.098.297-.2.434-.305a.792.792 0 00.07-.05c.16-.118.308-.243.453-.364.031-.031.066-.062.098-.09.109-.101.214-.199.312-.3.035-.036.067-.067.098-.102.12-.129.234-.258.34-.39"
        ></path>
        <path
          fill="#82D2F6"
          d="M120.105 834.477c0-12.825 10.614-23.223 23.7-23.223 10.574 0 19.53 6.793 22.578 16.168 2.683-5.45 8.355-9.219 14.941-9.219 6.88 0 12.781 4.102 15.301 9.942 0 0 1.273 3.37 1.613 7.375l-78.133-1.043M1030.578 600.984l-33.176-14.222 17.938-1.559-8.73-12.324-45.09-11.578 11.152-2.192-28.531-44.601-5.04 30.625-31.581 27.746 11.46 4.223-34.218 12.648-10.86 17.953 31.203-.324-39.058 22.941v21.051l43.68-13.527-2.207 1.937 11.46 4.227-34.218 12.644-10.86 17.953 31.203-.324-39.058 22.946v21.046l54.293-16.812 23.8-29.195 86.438 18.09V667.89l-33.176-14.227 17.938-1.559-8.73-12.324-41.622-13.797-3.16-16.922 68.75 14.391v-22.469"
        ></path>
        <path
          fill="#4CB9E0"
          d="M206.684 755.988c-6.45 3.692-8.852 12.383-5.368 19.41l23.352-13.359c-3.484-7.031-11.535-9.738-17.984-6.05M987.059 753.031c-6.48-.93-12.856 3.805-14.246 10.574l23.46 3.375c1.391-6.773-2.738-13.015-9.214-13.949"
        ></path>
        <path
          fill="#82D2F6"
          d="M166.3 788.898c-4.456-1.816-9.843.426-12.038 5.008l16.133 6.574c2.19-4.582.359-9.765-4.094-11.582M816.672 835.555c1.656-21.215 19.36-37.926 41-37.926 7.07 0 13.719 1.785 19.527 4.926 1.254-14.785 13.63-26.399 28.739-26.399 14.98 0 27.292 11.418 28.718 26.028a23.886 23.886 0 0113.496-4.153c11.57 0 21.227 8.18 23.516 19.07h8.074c3.34-4.402 8.613-7.257 14.567-7.257 10.101 0 18.293 8.187 18.293 18.293 0 2.64-.57 5.148-1.582 7.418H816.672"
        ></path>
        <path
          fill="#FFF"
          d="M726.762 835.531h-190v-11.949h190v11.95M926.52 835.531H727.203v-11.949H926.52v11.95"
        ></path>
        <path
          fill="#FFF"
          d="M906.68 823.883H705.387V801.21H906.68v22.672M704.969 823.625H363.05V524.953h341.918v298.672M813.832 391.094h-2.242l-120.102.004c.004-.004-241.676.007-241.676.007L338.863 511.004l13.84 9.8h363.8l97.106-115.179 92.028 115.18h13.558L813.832 391.094"
        ></path>
        <path
          fill="#FFF"
          d="M904.621 625.219l.016-104.414-92.028-115.18-97.105 115.18h-11.117v280.074H904.59l.023-135.383.008-40.277"
        ></path>
        <path
          fill="#FFF"
          d="M819.262 405.625l-5.063 6.05 97.09 111.356h8.606L819.262 405.625"
        ></path>
        <path
          fill="#319CC5"
          d="M813.7 407.152l-97.723 113.903-352.66.039v7.168l358.32-.059L814.07 421.36l80.22 99.672h11.456L813.7 407.152"
        ></path>
        <path
          fill="#FFF"
          d="M932.945 665.484h-225.36v-38.062h225.36v38.062M428.691 835.383h109.227v-147.73H428.691v147.73M289.414 835.531h139.277V687.652H289.414v147.88"
        ></path>
        <path
          fill="#82D2F6"
          d="M505.035 640.152h-99.492V570.32h99.492v69.832M661.926 640.152h-99.492V570.32h99.492v69.832M660.418 823.582h-90.711V678.988h90.711v144.594M516.3 746.355h-68.417v-26.832H516.3v26.832M403.527 835.223h-95.773v-81.696h95.773v81.696"
        ></path>
        <path
          fill="#FFF"
          d="M855.621 800.766h-71.95V699.617h71.95v101.149"
        ></path>
        <path
          fill="#82D2F6"
          d="M849.574 626.895h-65.902v-93.32h65.902v93.32"
        ></path>
        <path
          fill="#4CB9E0"
          d="M844.633 800.766h-60.961v-89.797h60.96v89.797"
        ></path>
        <path
          fill="#82D2F6"
          d="M356.902 835.223h-47.886v-81.696h47.886v81.696"
        ></path>
        <path
          fill="#319CC5"
          d="M829.395 731.145h-45.723V724h45.723v7.145"
        ></path>
        <path
          fill="#319CC5"
          d="M829.395 800.766h-7.192v-76.977h7.192v76.977M661.664 578.605h-100.23v-7.285h100.23v7.285"
        ></path>
        <path
          fill="#319CC5"
          d="M561.434 570.32h8.226v69.832h-8.226V570.32M504.027 578.605h-100.23v-7.285h100.23v7.285"
        ></path>
        <path
          fill="#319CC5"
          d="M404.797 570.32h8.226v69.832h-8.226V570.32M578.86 823.203h-9.153V678.988h9.152v144.215"
        ></path>
        <path
          fill="#319CC5"
          d="M569.707 678.988h90.711v8.664h-90.711v-8.664M447.883 719.523H516.3v5h-68.418v-5"
        ></path>
        <path
          fill="#319CC5"
          d="M447.883 719.523h4.867v26.832h-4.867v-26.832"
        ></path>
        <path
          fill="#4CB9E0"
          d="M736.652 665.637h-31.265v-38.742h31.265v38.742"
        ></path>
        <path
          fill="#319CC5"
          d="M704.805 824.68h-16.86V524.953h16.86V824.68M535.762 694.574H287.145v-6.922h248.617v6.922"
        ></path>
        <path
          fill="#4CB9E0"
          d="M427.27 688.906h108.07v5.668H427.27v-5.668M357.379 790.145l36.617-36.618h-11.86l-24.757 24.758v11.86M357.379 753.527v11.344l11.344-11.344zm0 0M357.379 803.555v11.855l46.82-46.816v-11.86l-46.82 46.82M362.402 835.656l41.797-41.793v-11.86l-46.82 46.817v6.836h5.023M387.672 835.656l16.527-16.523v-11.86l-28.387 28.383h11.86"
        ></path>
        <path
          fill="#FFF"
          d="M782.574 611.527v11.532l68.098-68.098V543.43l-68.098 68.097M802.781 627.422l47.89-47.895v-11.53l-59.421 59.425h11.531M811.18 533.785l-28.606 28.606v11.527l40.133-40.133H811.18"
        ></path>
        <path
          fill="#319CC5"
          d="M849.574 540.93h-65.902v-7.356h65.902v7.356"
        ></path>
        <path
          fill="#319CC5"
          d="M848.836 626.895h-8.41v-93.532h8.41v93.532M776.04 821.629h-10.993v-20.75h10.992v20.75"
        ></path>
        <path
          fill="#319CC5"
          d="M765.047 813.426h21.933v10.156h-21.933v-10.156M659.672 800.766h43.715v22.437h-43.715v-22.437M536.457 800.766h33.25v22.437h-33.25v-22.437M404.2 800.766h23.202v22.437H404.2v-22.437M286.348 800.766h23.203v22.437h-23.203v-22.437M433.695 687.652H283.367v-8.664h150.328v8.664"
        ></path>
        <path
          fill="#E4EEEF"
          d="M332.867 738.523h-19.969v-14.757h19.97v14.757M537.793 779.215h-19.969v-14.762h19.969v14.762M370.402 726.902h-29.52v-14.757h29.52v14.757"
        ></path>
        <path
          fill="#319CC5"
          d="M309.016 753.527h95.773v5.782h-95.773v-5.782"
        ></path>
        <path
          fill="#319CC5"
          d="M309.016 753.527h6.273v81.696h-6.273v-81.696"
        ></path>
        <path
          fill="#82D2F6"
          d="M712.246 511.004H338.863l77.38-83.617 33.57-36.282 364.019-.011-101.586 119.91"
        ></path>
        <path
          fill="#FFF"
          d="M632.508 359.094h-24.871v10.754h1.718v105.308h22.707v-.715L670 427.445v-57.597h1.195v-10.754h-38.687"
        ></path>
        <path
          fill="#319CC5"
          d="M631.484 475.156h-22.043V370.79h22.043v104.367"
        ></path>
        <path
          fill="#319CC5"
          d="M670.29 376.883H609.44v-6.82h60.848v6.82"
        ></path>
        <path
          fill="#82D2F6"
          d="M1086.148 803.719h-31.109v-19.067a3.94 3.94 0 013.941-3.937h23.23a3.936 3.936 0 013.938 3.937v19.067M327.973 615.48l-31.29-13.414 16.919-1.468-8.239-11.621-46.996-12.985h14.992l-26.902-42.062-4.75 28.879-29.785 26.168 10.808 3.984-32.27 11.926-10.241 16.93 29.43-.305-36.837 21.633v19.851l41.192-12.758-2.082 1.828 10.808 3.985-32.27 11.926-10.241 16.93 29.43-.305-36.837 21.632v19.852l51.2-15.856 22.445-27.535 81.516 17.067v-21.188l-31.29-13.418 16.919-1.468-8.239-11.622-39.246-13.007-2.98-15.961 64.836 13.57V615.48"
        ></path>
        <path
          fill="#4CB9E0"
          d="M1047.79 827.98h7.108s2.582 3.032 1.993 6.489h-19.82c3.85-5.407 10.718-6.489 10.718-6.489M1088.41 825.656l5.918-3.222s4 1.668 5.024 4.89l-16.114 8.332c0-5.414 5.172-10 5.172-10M1073.75 718.64c.648.825 1.262 1.68 1.82 2.563 1.61 2.543 2.828 4.293 3.578 7.219 4.07 15.906 5.332 36.871 5.332 36.871l-28.101.113 4.14-34.129 4.56-10.898 8.671-1.738"
        ></path>
        <path
          fill="#FFF"
          d="M1065.648 734.43c.582 5.343 1.993 12.722 3.23 16.394 0 0 .192 10.496 1.032 18.106h2.95s3.71-14.653 3.62-19.387c0 0-.101-11.113-1.539-17.418-.562-2.441-2.921-4.023-5.402-3.64-2.8.437-4.187 3.124-3.89 5.945"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1012.621 836.266l-3.2-1.422c.95-2.133 1.43-4.39 1.43-6.707 0-9.121-7.421-16.543-16.542-16.543-5.204 0-10.004 2.39-13.172 6.566l-.524.692h-10.367l-.293-1.391c-1.59-7.566-7.113-13.86-14.418-16.426a22.192 22.192 0 00-7.383-1.254 22.158 22.158 0 00-12.511 3.848l-2.442 1.66-.285-2.937c-1.36-13.938-12.957-24.446-26.976-24.446v-3.5c14.91 0 27.398 10.532 30.078 24.91a25.636 25.636 0 0112.136-3.035c2.93 0 5.805.489 8.543 1.45 8 2.812 14.157 9.488 16.352 17.62h5.851c3.829-4.624 9.395-7.257 15.41-7.257 11.051 0 20.044 8.992 20.044 20.043 0 2.808-.582 5.543-1.73 8.129"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1165.2 837.406H65.39v-3.5H1165.2v3.5M706.137 800.863h-3.5V522.555H363.789v156.43h-3.5v-159.93h345.848v281.808"
        ></path>
        <path
          fill="#1A1D3F"
          d="M906.344 802.629H702.637V519.055h12.054l97.954-116.188 93.742 117.32-.016 105.032h-3.5l.016-103.805-90.317-113.031-96.254 114.172h-10.18v276.574h196.708l.02-133.633h3.5l-.02 137.133"
        ></path>
        <path
          fill="#1A1D3F"
          d="M920.566 522.555h-16.77L812.57 408.383l-96.254 114.172H351.148l-15.941-11.285 115.094-121.915 158.054-.003v3.5l-156.546.003-111.29 117.887 11.743 8.313h362.43l97.953-116.188 92.832 116.188h7.793L811.992 392.844l-142.988.004v-3.5l144.672-.004 106.89 133.21M537.512 821.832h29.449v-19.219h-29.45zm32.949 3.5h-36.45v-26.219h36.45v26.219M706.137 821.832H904.78v-19.219H706.137zm202.144 3.5H702.637v-26.219H908.28v26.219"
        ></path>
        <path
          fill="#1A1D3F"
          d="M778.113 811.676h86.184v-8.98h-86.184zm89.684 3.5h-93.184v-15.98h93.184v15.98"
        ></path>
        <path
          fill="#1A1D3F"
          d="M787.73 821.832h87.618v-6.656H787.73zm91.118 3.5H784.23v-13.656h94.618v13.656"
        ></path>
        <path
          fill="#1A1D3F"
          d="M765.797 821.832h18.48l-.035-6.656h-9.629v-12.492l-8.816-.047zm21.996 3.5h-25.496v-26.215l15.816.082v12.477h9.61l.07 13.656M784.426 625.145h70.715v-98.442h-70.715zm74.215 3.5h-77.715V523.203h77.715v105.442"
        ></path>
        <path
          fill="#1A1D3F"
          d="M784.426 625.145h62.398v-89.82h-62.398zm65.898 3.5h-69.398v-96.82h69.398v96.82M784.426 799.016h68.445v-97.649h-68.445zm71.945 3.5h-75.445V697.867h75.445v104.649"
        ></path>
        <path
          fill="#1A1D3F"
          d="M784.426 799.016h57.46v-86.297h-57.46zm60.96 3.5h-64.46v-93.297h64.46v93.297"
        ></path>
        <path
          fill="#1A1D3F"
          d="M784.426 799.016h42.219V725.75h-42.22zm45.719 3.5h-49.22V722.25h49.22v80.266M706.137 663.734h224.789v-35.09h-224.79zm228.289 3.5h-231.79v-42.09h231.79v42.09"
        ></path>
        <path
          fill="#1A1D3F"
          d="M706.137 663.887h27.765v-35.242h-27.765zm31.265 3.5h-34.765v-42.242h34.765v42.242M406.293 638.402h95.992V572.07h-95.992zm99.492 3.5H402.793V568.57h102.992v73.332M563.184 638.402h95.992V572.07h-95.992zm99.492 3.5H559.684V568.57h102.992v73.332M570.46 821.832h87.208V680.738h-87.207zm90.708 3.5h-94.207V677.238h94.207v148.094"
        ></path>
        <path
          fill="#1A1D3F"
          d="M537.512 833.781h186.5v-8.449h-186.5zm190 3.5h-193.5v-15.449h193.5v15.45"
        ></path>
        <path
          fill="#1A1D3F"
          d="M727.512 833.781H924.77v-8.148H727.512zm200.758 3.5H724.012v-15.148H928.27v15.148M428.172 799.016h105.726V689.402H428.172zm109.226 3.5H424.672V685.902h112.726v116.614"
        ></path>
        <path
          fill="#1A1D3F"
          d="M428.172 837.281H285.395V691.215h3.5V833.78h135.777V689.402H328.52v-3.5h99.652v151.38"
        ></path>
        <path
          fill="#1A1D3F"
          d="M428.172 821.832h105.84v-19.219h-105.84zm109.34 3.5h-112.84v-26.219h112.84v26.219"
        ></path>
        <path
          fill="#1A1D3F"
          d="M428.172 833.781h105.84v-8.449h-105.84zm109.34 3.5h-112.84v-15.449h112.84v15.45M304.234 825.332h-18.84v-26.219h21.36v3.5h-17.86v19.219h15.34v3.5"
        ></path>
        <path
          fill="#1A1D3F"
          d="M428.281 825.332H403.79v-3.5h20.992v-19.219H403.79v-3.5h24.492v26.219"
        ></path>
        <path
          fill="#1A1D3F"
          d="M428.281 837.281H285.395v-15.449h21.359v3.5h-17.86v8.45h135.887v-10.2h3.5v13.7M434.445 685.902h99.453v-5.164h-99.453zm102.953 3.5H430.945v-12.164h106.453v12.164"
        ></path>
        <path
          fill="#1A1D3F"
          d="M434.445 689.402H328.652v-3.5h102.293v-5.164H327.77v-3.5h106.675v12.164M610.105 473.406h18.012V371.812h-18.012zm21.512 3.5h-25.012V368.312h25.012v108.594"
        ></path>
        <path
          fill="#1A1D3F"
          d="M631.617 371.8v99.22l35.637-43.41v-56zm-.304 105.106h-3.196V368.32l42.637-.23v60.77l-39.442 48.046"
        ></path>
        <path
          fill="#1A1D3F"
          d="M608.387 368.098h21.37v-7.254h-21.37zm24.87 3.5h-28.37v-14.254h28.37v14.254"
        ></path>
        <path
          fill="#1A1D3F"
          d="M633.035 368.098h35.41v-7.254h-35.41zm38.91 3.5h-42.41v-14.254h42.41v14.254M309.766 833.473h92.273v-78.196h-92.273zm95.773 3.5h-99.273v-85.196h99.273v85.196M448.637 744.605h64.914v-23.332h-64.914zm68.414 3.5h-71.914v-30.332h71.914v30.332M712.055 512.754H337.863v-3.5h372.57L811.5 389.96l2.668 2.262-102.113 120.53"
        ></path>
        <path
          fill="#1A1D3F"
          d="M357.652 835.223h-3.5v-81.696h3.5v81.696"
        ></path>
        <path
          fill="#1A1D3F"
          d="M355.902 781.762h-47.886v-3.5h47.886v3.5M355.902 811.293h-47.886v-3.5h47.886v3.5M456.04 640.152h-3.5V570.32h3.5v69.832"
        ></path>
        <path
          fill="#1A1D3F"
          d="M504.035 607.523H403.79v-3.5h100.246v3.5M613.668 640.152h-3.5V570.32h3.5v69.832"
        ></path>
        <path
          fill="#1A1D3F"
          d="M661.664 607.523H561.418v-3.5h100.246v3.5M615.813 823.582h-3.5V678.988h3.5v144.594"
        ></path>
        <path
          fill="#1A1D3F"
          d="M659.418 723.344h-90.707v-3.5h90.707v3.5M1042.398 832.383h11.723c-.172-.95-.601-1.781-.941-2.317h-5.309c-.57.114-3.082.684-5.473 2.317zm14.942 3.5h-22.63l1.97-2.77c3.832-5.379 10.48-6.48 10.761-6.523l.27-.024h7.18l.53.618c.11.136 2.829 3.382 2.169 7.246l-.25 1.453M1093.469 824.477l.011.003-.011-.003zm3.453 3.156c.008 0 .008.004.008.004s0-.004-.008-.004zm-7.39-.403c-.454.426-2.262 2.254-3.321 4.602l10.098-5.223c-.688-.851-1.637-1.48-2.27-1.836zm-4.321 8.692c-.66 0-1.332-.23-1.86-.672a2.995 2.995 0 01-.972-3.14c1.18-4.008 4.293-7.008 4.902-7.567.14-.121.27-.219.418-.3l.012-.009 5.258-2.863a2.227 2.227 0 012.011-.055c1.168.555 4.032 2.157 5.18 4.993.43 1.03-.02 2.257-1.031 2.78l-12.559 6.5c-.43.223-.89.333-1.36.333"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1055.352 830.066h-9.442l.05-1.793c.09-3.503.86-34.296 1.118-36.27.121-.87 1.703-6.964 4.98-19.452 1.18-4.48 2.294-8.715 2.391-9.196l3.422.735c-.11.531-.95 3.734-2.422 9.351-1.89 7.18-4.738 18.032-4.898 19.04-.172 1.343-.7 20.476-1.051 34.085h3.309c1.18-3.652 4.671-14.683 5.722-20.222a27.44 27.44 0 00.438-3.742l3.5.191c-.09 1.508-.25 2.922-.5 4.203-1.309 6.89-6.02 21.262-6.219 21.867l-.398 1.203M1041.488 768.184a.782.782 0 001.063-.305l1.73-3.117-2.8 2.27a.87.87 0 00-.31.616.485.485 0 00.15.41c.05.047.1.09.167.126zm.371 3.601c-.71 0-1.418-.18-2.058-.535a4.341 4.341 0 01-.93-.688 3.973 3.973 0 01-1.191-3.074 4.33 4.33 0 011.601-3.172l3.07-2.5a3.444 3.444 0 013.91-.293 3.412 3.412 0 011.259 4.61l-1.899 3.437c-.55 1-1.46 1.727-2.57 2.043-.39.117-.79.172-1.192.172"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1045.91 762.602l.16.113c1.98-1.617 6.371-5.219 9.328-7.824l.813-5.813c-1.2 1.36-6.73 7.707-10.3 13.524zm.281 4.52l-4.902-3.54.781-1.363c3.73-6.57 10.258-14.035 11.559-15.5.59-1.54 3.293-8.598 4.68-12.309l5.582-14.87-5.211 37.112-.48.43c-3.9 3.473-10.9 9.14-10.97 9.195l-1.039.844M1070.16 692.457c-1.262 0-2.62.41-3.898 1.2-2.024 1.245-3.551 3.226-4.301 5.57-1.633 5.05.23 12.011 3.5 13.062 3.258 1.055 8.84-3.508 10.469-8.559 1.62-5.023-.86-9.964-4.16-11.027a5.233 5.233 0 00-1.61-.246zm-3.738 23.477a6.662 6.662 0 01-2.043-.313c-5.55-1.793-7.809-11.101-5.758-17.469 1.02-3.136 3.078-5.789 5.809-7.472 2.718-1.68 5.789-2.157 8.41-1.309 5.5 1.774 8.5 8.984 6.422 15.434-1.813 5.613-7.684 11.129-12.84 11.129"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1060.07 725.434l5.04-11.907 3.218 1.364-1.367 3.25 4.687-2.313-.777-4 3.438-.668 1.293 6.625-15.532 7.649M1081.71 781.71l-3.37-.94.601-2.133c1.13-4.61 1.63-9.516 1.5-14.953l3.5-.079c.13 5.75-.402 10.957-1.62 15.918l-.61 2.188M1059.441 781.605l-3.8-17.703 3.43-.73 3.788 17.703-3.418.73M1087.828 828.258l-19.508-24.473 2.73-2.18 17.669 22.157 3.043-1.688c-1.57-3.527-5.692-12.664-8.742-18.578l3.109-1.601c3.883 7.515 9.43 20.101 9.48 20.226l.641 1.465-8.422 4.672"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1054.129 765.719l4.45-36.621 4.69-11.215 3.22 1.347-4.5 10.766-3.91 32.207 7.35-.031.012 3.5-11.312.047M1076.8 765.629l-.01-3.5 5.769-.024c-.41-5.476-1.868-22.039-5.188-35-.621-2.421-1.61-3.972-2.973-6.12l-.418-.657a29.035 29.035 0 00-1.73-2.437l2.75-2.168c.691.879 1.34 1.797 1.93 2.73l.422.652c1.418 2.239 2.648 4.168 3.41 7.13 4.097 16.015 5.41 37.292 5.43 37.507l.109 1.848-9.5.039M1071 771.55l-.86 3.208a.82.82 0 00.098.648c.09.14.211.219.34.239.07.007.14.007.211 0a.74.74 0 00.492-.282.74.74 0 00.16-.554zm-.309 7.602c-.21 0-.421-.015-.62-.047a3.962 3.962 0 01-2.75-1.777 4.28 4.28 0 01-.56-3.48l1.02-3.782 3.14.844-.03-.187 3.468-.465.551 4.105a4.23 4.23 0 01-.87 3.157 4.231 4.231 0 01-3.349 1.632"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1071.07 768.738h.192c1.226-5.027 3.539-15.258 3.468-18.843 0-.133-.12-11.73-1.601-18.172-.379-1.688-2.027-2.797-3.758-2.535-2.121.332-2.871 2.515-2.672 4.41.621 5.761 2.121 13.418 3.352 17.07l.09.258v.265c0 .106.187 9.813.93 17.547zm2.918 3.5h-6.066l-.172-1.558c-.809-7.383-1.059-17.399-1.102-19.153-1.296-3.996-2.789-11.617-3.43-17.554-.448-4.203 1.91-7.668 5.61-8.243 3.531-.55 6.922 1.743 7.723 5.211 1.558 6.813 1.68 18.414 1.68 18.907.097 5.191-3.743 20.425-3.91 21.07l-.333 1.32M1056.7 800.945h28.402v-15.668a2.29 2.29 0 00-2.293-2.289h-23.82a2.295 2.295 0 00-2.29 2.29zm31.902 3.5h-35.403v-19.168a5.799 5.799 0 015.79-5.789h23.82a5.792 5.792 0 015.793 5.79v19.167"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1056.7 789.402h28.402v-4.125a2.29 2.29 0 00-2.293-2.289h-23.82a2.295 2.295 0 00-2.29 2.29zm31.902 3.5h-35.403v-7.625a5.799 5.799 0 015.79-5.789h23.82a5.792 5.792 0 015.793 5.79v7.624M1076.738 709.598l-2.808-2.078c.898-1.223 1.59-2.536 2-3.79 1.62-5.023-.86-9.964-4.16-11.027-2.649-.86-5.93.535-8.06 3.246l1.11.48 6.91-.074-.851 4.872 2.172.664-1.02 3.343-5.12-1.566.648-3.77-3.438.04-5.441-2.34.89-1.672c2.782-5.281 8.489-8.094 13.27-6.555 5.5 1.774 8.5 8.984 6.422 15.434-.532 1.633-1.383 3.246-2.524 4.793"
        ></path>
        <path
          fill="#1A1D3F"
          d="M1079.05 782.988h-15.878v-6.37a4.422 4.422 0 014.418-4.423h.95v3.5h-.95a.918.918 0 00-.918.922v2.871h8.879v-2.87a.921.921 0 00-.922-.923h-1.43v-3.5h1.43a4.425 4.425 0 014.422 4.422v6.371M1079.05 793.95h-3.5v-6.036h3.5v6.035M1066.672 793.95h-3.5v-6.036h3.5v6.035M252.184 836.277h-3.5v-152.66h3.5v152.66"
        ></path>
        <path
          fill="#1A1D3F"
          d="M174.563 707.238v16.477l48.425-15 22.785-27.95 80.45 16.84v-17.878l-33.797-14.493 18.113-2.84-6.273-8.843-39.676-13.156-3.656-19.543 65.289 13.664v-17.88l-36.637-15.71 20.82-1.809-6.11-8.62-45.456-12.56 11.746-3.035-23.145-36.183-4.109 24.992-28.047 24.64 12.5 4.606-36.144 13.36-8.297 13.718 32.855-.344-41.637 24.457v16.543l37.434-10.46 15.79 5.816-36.145 13.36-8.297 13.718 32.855-.344zm-3.5 21.223v-23.227l32.03-18.812-25.995.27 12.183-20.145 28.395-10.492-5.828-2.149-40.786 11.395v-23.156l32.032-18.817-25.996.274 12.183-20.145 28.395-10.496-9.117-3.356 31.523-27.699 5.387-32.765 30.668 47.941-3.746.969 34.039 9.406 10.367 14.621-13.012 1.129 25.938 11.121v24.496l-64.387-13.476 2.312 12.375 38.813 12.867 10.203 14.39-11.684 1.832 24.743 10.61v24.492L247.14 684.63l-22.106 27.117-53.972 16.715M950.11 798.238h-3.5v-127.12h3.5v127.12"
        ></path>
        <path
          fill="#1A1D3F"
          d="M905.152 707.996l-1.035-3.344 15.2-4.707 24.14-29.613 85.371 17.871v-19.16l-35.558-15.246 19.011-2.985-6.77-9.546-42.05-13.946-3.832-20.508 69.2 14.489v-19.16l-38.524-16.52 21.843-1.898-6.609-9.325-47.86-13.222 12.216-3.156-24.77-38.723-4.398 26.734-29.844 26.223 13.152 4.848-18.793 6.945-1.21-3.285 9.894-3.657-9.77-3.597 33.32-29.278 5.676-34.511 32.293 50.48-4.215 1.09 36.442 10.07 10.867 15.325-14.039 1.214 27.828 11.934v25.777l-68.3-14.297 2.492 13.336 41.18 13.657 10.71 15.09-12.59 1.972 26.508 11.367v25.778l-87.504-18.317-23.465 28.782-16.207 5.02M197.367 836.434c-.316-3.825-1.515-7.118-1.527-7.149-2.332-5.504-7.77-9.11-13.828-9.11-5.813 0-11 3.266-13.535 8.52l-1.91 3.957-1.333-4.183a22.138 22.138 0 00-21.168-15.465c-12.246 0-22.21 9.965-22.21 22.21h-3.5c0-14.179 11.535-25.71 25.71-25.71 10.02 0 18.93 5.71 23.164 14.531 3.461-4.61 8.856-7.36 14.782-7.36a18.52 18.52 0 0117.082 11.321c.086.227 1.402 3.828 1.761 8.145l-3.488.293"
        ></path>
      </g>
    </svg>
  );
}

export default Home;
